import type ExampleMetaExport from "@/types/examples";

export default {
  displayName: "CSP-S2024",
  title: "2024 CCF 非专业级软件能力认证",
  template: "cnoi",
  description: (
    <>
      原始 PDF：
      <a
        href="https://qoj.ac/download.php?type=attachments&id=1848&r=0"
        target="_blank"
      >
        https://qoj.ac/download.php?type=attachments&id=1848&r=0
      </a>
    </>
  ),
} satisfies ExampleMetaExport;
